"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "LogicalSelectField", {
  enumerable: true,
  get: function get() {
    return _index["default"];
  }
});
exports["default"] = void 0;

var _index = _interopRequireWildcard(require("../LogicalSelectField/index"));

/**
 * DEPRECATED - only exists for backwards compatibility
 */
var _default = _index.LogicalSelect;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/Form/LogicalSelect.js
// module id = 522
// module chunks = 0